import { administrationHttpClient } from '../../../http/axios/axios-http-client';
import { SendHealerFeedbackDTO } from './dto/send-healer-feedback';

export interface HealerFeedbackGateway {
  healerFeedback(healerFeedback: SendHealerFeedbackDTO, bookingId?: string, file?: File): Promise<void>;
}

export class HealerFeedbackGateway implements HealerFeedbackGateway {
  async healerFeedback(healerFeedback: SendHealerFeedbackDTO, bookingId?: string, file?: File) {
    const endpoint = `/healer-session-feedback/${bookingId}`;

    // Create a new FormData object
    const formData = new FormData();

    // Append the healer feedback as a JSON string
    formData.append('body', new Blob([JSON.stringify(healerFeedback)], { type: 'application/json' }));

    // If a file is provided, append it to the FormData object
    if (file) {
      formData.append('file', file);
    }

    // Make the request using FormData
    await administrationHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}
